import type { ChapterItem } from '@app/_proto/Protos/chapters';
import { ObjectType } from '@app/_proto/Protos/objects';
import { getAdminUrl, useAuth } from '@app/libs/auth';
import { Button } from '@mui/material';
import { useMemo } from 'react';

type Props = {
    chapter?: ChapterItem;
};

export default function ChapterEditButton({ chapter }: Props) {
    const { user } = useAuth();

    const hasUserEditPermission = useMemo(() => {
        if (!!user && !!chapter) {
            const userCanAccessAdminPanel = user.permissions?.roles.some(f => f.name === 'ControlPanel');

            //No point in showing the edit button if user cannot access the backend admin panel.
            if (userCanAccessAdminPanel) {
                //For translator and editor permissions
                const isAssociatedWithNovel = user.permissions?.objects.some(
                    f => f.type === ObjectType.NovelObject && f.id === chapter.novelId
                );

                //For all other roles except for translator and editor
                const allowedRoles = ['Admin', 'Staff', 'ContentManager'];

                const hasAllowedRoles = user.permissions?.roles.some(f => allowedRoles.includes(f.name));

                if (isAssociatedWithNovel || hasAllowedRoles) {
                    return true;
                }
            }
        }
        return false;
    }, [chapter, user]);

    if (!hasUserEditPermission) {
        return null;
    }

    return (
        <div className="py-[10px] text-center">
            <Button
                href={getAdminUrl(`/novels/${chapter?.novelInfo?.slug}/chapters/${chapter?.slug}`)}
                LinkComponent="a"
                target="_blank"
                variant="outlined"
                color="secondary"
            >
                Edit chapter
            </Button>
        </div>
    );
}
